import {Expose} from 'class-transformer';

export class PickupTimeApiModel {
  @Expose()
  id: string;

  @Expose()
  time: number;
}
